export default __webpack_public_path__ + "static/media/Rekha.dedf96ff.ttf";